import { r2Fetch } from './client';

export interface R2FileBulkTransferParams {
  from_bucket_id: string;
  to_bucket_id: string;
  keys: string[];
}

export interface R2FileBulkTransferResponse {
  transferred: number;
  errors?: Array<{ key: string; error: string }>;
}

export async function r2FileBulkTransfer(
  params: R2FileBulkTransferParams
): Promise<R2FileBulkTransferResponse> {
  return r2Fetch<R2FileBulkTransferResponse>('/rpc/r2_file_bulk_transfer', {
    body: params,
  });
}
